// Independent EASYFEET quiz cache refresh: 2026-09-03.
(() => {
  const PRODUCT_PRIORITY = [
    'black-onyx-premium-orthotic-insoles',
    'black-model-plantar-fasciitis-insoles',
    'core-energy-high-arch-support-insoles',
    'mount-strength-orthotic-insoles',
    'flame-boost-sport-insoles',
    'blue-model-narrow-orthotic-insoles',
    'hiking-kinergy-insoles',
    'hiking-insoles-kinergy-lime'
  ];

  const LINKED_VARIANT_SKUS = {
    'black-onyx-premium-orthotic-insoles': 'BO-M',
    'black-model-plantar-fasciitis-insoles': 'US-Black-M',
    'core-energy-high-arch-support-insoles': 'US-Core-M',
    'mount-strength-orthotic-insoles': 'US-MS-M',
    'flame-boost-sport-insoles': 'US-FB-M',
    'blue-model-narrow-orthotic-insoles': 'NB-M',
    'hiking-kinergy-insoles': 'KN-HIK-M',
    'hiking-insoles-kinergy-lime': 'KN-HIKNW-M'
  };

  const VOTES = {
    'question-1': {
      'daily-comfort': ['black-onyx-premium-orthotic-insoles', 'blue-model-narrow-orthotic-insoles'],
      'pain-relief': ['core-energy-high-arch-support-insoles', 'mount-strength-orthotic-insoles', 'black-onyx-premium-orthotic-insoles'],
      'athletic-performance': ['flame-boost-sport-insoles', 'hiking-kinergy-insoles', 'hiking-insoles-kinergy-lime'],
      work: ['blue-model-narrow-orthotic-insoles', 'core-energy-high-arch-support-insoles']
    },
    'question-2': { women: [], men: [], 'prefer-not-to-answer': [] },
    'question-3': {
      'less-than-220': ['core-energy-high-arch-support-insoles', 'black-model-plantar-fasciitis-insoles', 'flame-boost-sport-insoles', 'blue-model-narrow-orthotic-insoles', 'black-onyx-premium-orthotic-insoles', 'hiking-kinergy-insoles', 'hiking-insoles-kinergy-lime'],
      'more-than-220': ['mount-strength-orthotic-insoles']
    },
    'question-4': {
      'no-pain': ['blue-model-narrow-orthotic-insoles', 'hiking-kinergy-insoles'],
      'whole-body': ['black-onyx-premium-orthotic-insoles', 'black-model-plantar-fasciitis-insoles', 'mount-strength-orthotic-insoles'],
      back: ['black-model-plantar-fasciitis-insoles', 'mount-strength-orthotic-insoles', 'hiking-insoles-kinergy-lime'],
      knees: ['flame-boost-sport-insoles', 'black-model-plantar-fasciitis-insoles', 'mount-strength-orthotic-insoles', 'hiking-insoles-kinergy-lime', 'hiking-kinergy-insoles'],
      'feet-ankles': ['mount-strength-orthotic-insoles', 'black-onyx-premium-orthotic-insoles', 'hiking-kinergy-insoles']
    },
    'question-5': {
      athletic: ['flame-boost-sport-insoles', 'hiking-insoles-kinergy-lime'],
      casual: ['black-onyx-premium-orthotic-insoles', 'blue-model-narrow-orthotic-insoles', 'black-model-plantar-fasciitis-insoles', 'core-energy-high-arch-support-insoles', 'mount-strength-orthotic-insoles', 'flame-boost-sport-insoles', 'hiking-insoles-kinergy-lime'],
      'hiking-boots': ['hiking-kinergy-insoles', 'hiking-insoles-kinergy-lime', 'black-onyx-premium-orthotic-insoles', 'black-model-plantar-fasciitis-insoles', 'core-energy-high-arch-support-insoles', 'mount-strength-orthotic-insoles'],
      'hunting-boots': ['core-energy-high-arch-support-insoles', 'black-model-plantar-fasciitis-insoles', 'mount-strength-orthotic-insoles', 'hiking-kinergy-insoles', 'black-onyx-premium-orthotic-insoles'],
      'office-career': ['black-onyx-premium-orthotic-insoles', 'blue-model-narrow-orthotic-insoles'],
      running: ['flame-boost-sport-insoles', 'hiking-insoles-kinergy-lime'],
      skates: ['flame-boost-sport-insoles', 'hiking-insoles-kinergy-lime'],
      'snowboard-boots': ['black-model-plantar-fasciitis-insoles', 'flame-boost-sport-insoles', 'black-onyx-premium-orthotic-insoles', 'hiking-kinergy-insoles', 'core-energy-high-arch-support-insoles', 'mount-strength-orthotic-insoles'],
      'ski-boots': ['black-model-plantar-fasciitis-insoles', 'flame-boost-sport-insoles', 'hiking-kinergy-insoles'],
      waders: ['black-model-plantar-fasciitis-insoles', 'mount-strength-orthotic-insoles', 'hiking-kinergy-insoles'],
      walking: ['black-onyx-premium-orthotic-insoles', 'flame-boost-sport-insoles', 'hiking-insoles-kinergy-lime'],
      'work-duty': ['core-energy-high-arch-support-insoles', 'mount-strength-orthotic-insoles', 'black-onyx-premium-orthotic-insoles', 'blue-model-narrow-orthotic-insoles']
    },
    'question-6': {
      tight: ['blue-model-narrow-orthotic-insoles'],
      snug: ['core-energy-high-arch-support-insoles', 'hiking-insoles-kinergy-lime'],
      'just-right': ['black-onyx-premium-orthotic-insoles', 'black-model-plantar-fasciitis-insoles', 'hiking-kinergy-insoles'],
      roomy: ['mount-strength-orthotic-insoles']
    },
    'question-7': {
      flat: ['hiking-insoles-kinergy-lime', 'flame-boost-sport-insoles'],
      standard: ['flame-boost-sport-insoles', 'blue-model-narrow-orthotic-insoles', 'hiking-kinergy-insoles'],
      high: ['core-energy-high-arch-support-insoles', 'black-model-plantar-fasciitis-insoles', 'black-onyx-premium-orthotic-insoles', 'mount-strength-orthotic-insoles'],
      'hard-to-say': []
    },
    'question-8': {
      narrow: ['blue-model-narrow-orthotic-insoles'],
      standard: ['black-model-plantar-fasciitis-insoles', 'flame-boost-sport-insoles', 'core-energy-high-arch-support-insoles', 'black-onyx-premium-orthotic-insoles'],
      wide: ['mount-strength-orthotic-insoles'],
      'hard-to-say': []
    }
  };

  const money = (cents) => (Number(cents) / 100).toFixed(2) + ' USD';

  const initialiseQuiz = (quiz) => {
    if (quiz.dataset.initialised === 'true') return;
    quiz.dataset.initialised = 'true';
    const screens = new Map(Array.from(quiz.querySelectorAll('[data-quiz-screen]')).map((screen) => [screen.dataset.quizScreen, screen]));
    const answers = {};
    let resultsRendered = false;
    let advanceTimer;

    const rankedHandles = (eligibleHandles) => {
      const scores = Object.fromEntries(PRODUCT_PRIORITY.map((handle) => [handle, 0]));
      Object.entries(answers).forEach(([question, answer]) => {
        (VOTES[question]?.[answer] || []).forEach((handle) => { scores[handle] += 1; });
      });
      return eligibleHandles
        .map((handle) => ({ handle, score: scores[handle], tieBreaker: Math.random() }))
        .filter((entry) => entry.score >= 2)
        .sort((a, b) => b.score - a.score || b.tieBreaker - a.tieBreaker)
        .slice(0, 2)
        .map((entry) => entry.handle);
    };

    const renderResults = async () => {
      const container = quiz.querySelector('[data-quiz-products]');
      const loading = quiz.querySelector('[data-quiz-loading]');
      container.replaceChildren();
      loading.hidden = false;
      try {
        const catalogue = await Promise.all(PRODUCT_PRIORITY.map(async (handle) => {
          const response = await fetch('/products/' + handle + '.js');
          if (!response.ok) throw new Error('Product unavailable');
          const product = await response.json();
          const linkedVariant = product.variants.find((variant) => variant.sku === LINKED_VARIANT_SKUS[handle]);
          return { handle, product, linkedVariant };
        }));
        const eligibleHandles = catalogue
          .filter((entry) => entry.linkedVariant?.available)
          .map((entry) => entry.handle);
        const ranked = rankedHandles(eligibleHandles);
        const recommendations = ranked.map((handle) => catalogue.find((entry) => entry.handle === handle));
        recommendations.forEach(({ product, linkedVariant }) => {
          const card = document.createElement('article');
          card.className = 'easyfeet-quiz__product';
          const compare = Number(product.compare_at_price) > Number(product.price) ? '<s>' + money(product.compare_at_price) + '</s>' : '';
          const productUrl = product.url + (product.url.includes('?') ? '&' : '?') + 'variant=' + linkedVariant.id;
          card.innerHTML = '<img class="easyfeet-quiz__product-image" src="' + product.featured_image + '" alt="' + product.title + '">' +
            '<h3>' + product.title + '</h3>' +
            '<p class="easyfeet-quiz__price"><strong>' + money(product.price) + '</strong> ' + compare + '</p>' +
            '<a class="easyfeet-quiz__product-link" href="' + productUrl + '">View product</a>';
          container.appendChild(card);
        });
        if (!recommendations.length) container.textContent = 'Based on your answers, we need a little more time to give you our recommendations. Please get in touch with us.';
        resultsRendered = true;
      } catch (error) {
        container.textContent = 'We could not load the recommendations. Please try again.';
      } finally {
        loading.hidden = true;
      }
    };

    const showScreen = (name) => {
      window.clearTimeout(advanceTimer);
      quiz.dataset.transitioning = 'false';
      screens.forEach((screen, key) => { screen.hidden = key !== name; });
      screens.get(name)?.querySelector('.easyfeet-quiz__title')?.focus();
      if (name === 'results' && !resultsRendered) renderResults();
    };

    quiz.addEventListener('click', (event) => {
      if (event.target.closest('[data-quiz-start]')) { showScreen('question-1'); return; }
      const back = event.target.closest('[data-quiz-prev-to]');
      if (back) { event.preventDefault(); showScreen(back.dataset.quizPrevTo); return; }
      const answer = event.target.closest('[data-quiz-answer]');
      if (answer) {
        if (quiz.dataset.transitioning === 'true') return;
        const question = answer.closest('[data-quiz-question]');
        question.querySelectorAll('[data-quiz-answer]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        answer.setAttribute('aria-pressed', 'true');
        answers[question.dataset.quizQuestion] = answer.dataset.quizAnswer;
        const next = question.querySelector('[data-quiz-next-to]');
        next.disabled = false;
        resultsRendered = false;
        quiz.dataset.transitioning = 'true';
        advanceTimer = window.setTimeout(() => showScreen(next.dataset.quizNextTo), 180);
        return;
      }
      const next = event.target.closest('[data-quiz-next-to]');
      if (next && !next.disabled) { showScreen(next.dataset.quizNextTo); return; }
      if (event.target.closest('[data-quiz-restart]')) {
        Object.keys(answers).forEach((key) => delete answers[key]);
        quiz.querySelectorAll('[data-quiz-answer]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        quiz.querySelectorAll('[data-quiz-next-to]').forEach((button) => { button.disabled = true; });
        resultsRendered = false;
        showScreen('intro');
      }
    });
  };

  const initialiseAll = (scope = document) => scope.querySelectorAll('[data-easyfeet-quiz]').forEach(initialiseQuiz);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseAll());
  else initialiseAll();
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
